<template>
  <div>
    <Header theme="white" @setScroll="setScroll"></Header>
    <div>
      <div class="banner"
        :style="{'background': 'rgb(15, 94, 255) url(' + baseUrl + content.topBigImage + ')','background-repeat':'no-repeat','background-size':'cover'}">
        <div class="top">
          <div>
            <div class="topTitle">{{content.topTitle}}</div>
            <div class="topContent">{{content.topContent}}</div>
          </div>
          <div class="topSmallImage">
            <img :src="baseUrl + content.topSmallImage" alt="">
          </div>
        </div>
      </div>
    </div>

   <!-- <a href="baseUrl + content.fileUrl" target="downloadFile" download="aa.pdf">附件下载121</a> -->
   <!-- <iframe style="display:none" name="downloadFile"></iframe> -->
    <div class="solution">
        <div class="solutionContent">
            <div style="display: flex;align-items: center;margin: 15px 0;">
              <span class="fa">解决方案</span>
              <span class="forLibne"></span>
              <span class="program">PROGRAM</span>
            </div>
            <div class="contentFire">{{content.solutionText}}</div>
            <div class="solutionImage">
              <img :src="baseUrl + content.solutionImage">
            </div>
        </div>
    </div>
    <div class="highlights">
        <div class="highlightsContent">
            <div style="display: flex;align-items: center;margin: 15px 0;">
              <span class="fa">方案亮点</span>
              <span class="forLibne"></span>
              <span class="program">PROGRAM</span>
            </div>
            <div class="highlightsImage">
              <img :src="baseUrl + content.solutionHighImage">
            </div>
        </div>
    </div>
    <div class="value" v-if="content.solutionValue">
        <div class="valueContent">
            <div style="display: flex;align-items: center;margin: 15px 0;">
              <span class="fa">方案价值</span>
              <span class="forLibne"></span>
              <span class="program">VALUE</span>
            </div>
            <div class="contentFire">{{content.solutionValue}}</div>
        </div>
    </div>
    <div class="case" v-if="content.solutionAppImage">
        <div class="caseContent">
            <div style="display: flex;align-items: center;margin: 15px 0;">
              <span class="fa">应用案例</span>
              <span class="forLibne"></span>
              <span class="program">APPLICATIONS</span>
            </div>
            <div class="caseImage">
              <img :src="baseUrl + content.solutionAppImage">
            </div>
        </div>
    </div>

    <div class="downBox" v-if="content.fileUrl">
      <a class="downBtn" @click="downFile(content.fileUrl)">附件下载</a>
    </div>
    <!--页脚-->
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    solutionById
  } from '@/api/api'
  export default {
    data() {
      return {
        scroll: 'home',
        id: '',
        content: {},
        baseUrl: serverUrl.baseURL
      }
    },
    watch: {    '$route' (to, from) {
            this.$router.go(0);
        }
    },
    components: {
      Header,
      Footer
    },
    created() {
      this.id = this.$route.query.data
      this.getSolutionById()
    },
    methods: {
      downFile(url) {
        if (!url) return
        let filename = url.substring(url.lastIndexOf('/')+1)
        let link = document.createElement('a') //创建a标签
        link.style.display = 'none'  //使其隐藏
        link.href = this.baseUrl + url //赋予文件下载地址
        link.setAttribute('download',filename) //设置下载属性 以及文件名
        document.body.appendChild(link) //a标签插至页面中
        link.click() //强制触发a标签事件
        document.body.removeChild(link);
      },
      setScroll(eId) {
        this.scroll = eId
      },
      getSolutionById() {
        solutionById({
          id: this.id
        }).then(res => {
          this.content = res.data
        })
      },
      hanldeDownFile() {
        alert('todo')
      }
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    height: 693px;
    display: flex;
    align-items: center;
    color: #fff;
  }

  .top {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .topTitle {
    font-size: 34px;
    line-height: 70px;
    font-weight: 700;
  }

  .topSmallImage {
    margin-top: 150px;
  }

  .topContent {
    width: 666px;
    font-size: 20px;
    line-height: 35px;
  }

  .solution, .highlights, .case, .value {
    width: 100%;
    margin: 60px 0;
  }

  .solutionContent, .highlightsContent, .caseContent, .valueContent {
    width: 1189px;
    margin: 0 auto;
    /* border: 1px solid red; */
  }

  .fa {
        font-size: 32px;
        font-weight: 700;
  }

  .program {
    color: #173381;
        font-size: 32px;
        font-weight: 700;
  }

  .forLibne {
    display: inline-block;
        width: 2px;
        height: 32px;
        background-color: #232323;
        margin: 0 15px;
  }

  .contentFire {
    font-size: 20px;
        line-height: 40px;
        text-indent: 2em;
        height: auto;
        width: 100%;
        color: #000;
  }

  .solutionImage {
    margin: 10px;
  }

  .solutionImage img {
    width: 1189px;
  }

  .highlightsImage, .solutionImage, .caseImage {
    text-align: center;
  }
  .downBtn{
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    padding: 8px 30px;
    background: #2B69E7;
    border-radius: 23px;
    border: 1px solid #2B69E7;
    cursor: pointer;
  }
  .downBox{
   width: 1200px;
   margin: 0 auto;
   padding: 10px 0 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/solution/DetailsPage.vue